import orders from '../../../assets/images/user-assets/orders/orders.png';
// import location from '../../../assets/images/cart-assets/location/location.png';
// import email from '../../../assets/images/user-assets/email/email.png';
// import payment from '../../../assets/images/user-assets/payment/payment.png';

import tomatoes from '../../../assets/images/cart-assets/tomatoes/tomatoes.jpg';
import lays from '../../../assets/images/cart-assets/lays/lays.png';
import saffola from '../../../assets/images/cart-assets/saffola/saffola.jpg';
import strawberries from '../../../assets/images/cart-assets/strawberries/strawberries.jpg';



export const orderIdAndPrice = [
    {
        "id" : 1,
        "orderIcon" : orders,
        "orderId" : "Order Id : 2348768755878",
        "orderDateAndTime" : "21 April, 2021  | 10:15 am",
        "orderPrice" : "AED 391.00"
    }
]


export const myOrders = [
    {
        "id" : 1,
        "orderItem" : tomatoes,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },
    {
        "id" : 2,
        "orderItem" : lays,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },
    {
        "id" : 3,
        "orderItem" : strawberries,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },
    {
        "id" : 4,
        "orderItem" : saffola,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },
    {
        "id" : 5,
        "orderItem" : tomatoes,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },
    {
        "id" : 6,
        "orderItem" : tomatoes,
        "orderName" : "Fresh packed tomatoes",
        "orderQuantity" : "QTY 2",
    },

]

export const deliveredOrders = [
    {
        "id" : 1,
        "orderIcon" : orders,
        "orderId" : "Order Id : 2348768755878",
        "orderDateAndTime" : "21 April, 2021  | 10:15 am",
        "orderPrice" : "AED 391.00",
        "orderStatus" : "Delivered"
    },
    {
        "id" : 2,
        "orderIcon" : orders,
        "orderId" : "Order Id : 2348768755878",
        "orderDateAndTime" : "21 April, 2021  | 10:15 am",
        "orderPrice" : "AED 391.00",
        "orderStatus" : "Delivered"
    },
    {
        "id" : 3,
        "orderIcon" : orders,
        "orderId" : "Order Id : 2348768755878",
        "orderDateAndTime" : "21 April, 2021  | 10:15 am",
        "orderPrice" : "AED 391.00",
        "orderStatus" : "Delivered"
    }

]
